import { CLEAR_STATE, FULFILL_EXPIRED_SIGNALS, FULFILL_SIGNAL, FULFILL_SIGNALS } from '../constants'
import { ClearState } from '../actions/commonActions'
import { FulfillExpiredSignals, FulfillSignal, FulfillSignals } from '../actions/signalsActions'
import { Signals } from '@bdswiss/mt4-connector'
import { pickBy, isEmpty } from 'lodash'

// FIXME: Temporary filter out signals for symbols with multiple sessions per day
const excludedSymbols = ['NAS100', 'US30', 'SPX500', 'AUS_200', 'HKG_50']

export function signals(
  state = defaultState,
  action: FulfillSignals | FulfillSignal | FulfillExpiredSignals | ClearState
): Signals {
  switch (action.type) {
    case FULFILL_SIGNALS: {
      const { signals } = action
      const selectedSignals = pickBy(
        signals,
        (value, key) => !excludedSymbols.includes(value.symbol)
      )
      return isEmpty(selectedSignals) ? state : selectedSignals
    }
    case FULFILL_SIGNAL: {
      const { signal } = action
      return excludedSymbols.includes(signal.symbol) ? state : { ...state, [signal.id]: signal }
    }
    case FULFILL_EXPIRED_SIGNALS: {
      const { expiredSignals: data } = action
      return pickBy(state, (value, key) => !data.expired.includes(key))
    }
    case CLEAR_STATE: {
      return { ...defaultState }
    }
    default:
      return state
  }
}

const defaultState: Signals = {}
